// Convierte un número a su expresión en letras, en minúsculas y sin la palabra
// "pesos": son los comprobantes los que agregan " PESOS MCTE", y algunos deciden
// si va "DE" mirando si el texto termina en "millón" o "millones". Por eso el
// resultado no lleva espacios de más ni al final.
//
// La versión anterior de este archivo escribía mal varias cifras: "$150.000" salía
// como "cien mil", "$21.000" como "veintiuno mil" y las centenas dejaban espacios
// dobles. Se reescribió respetando esas dos condiciones de salida.

const UNIDADES = [
    '', 'uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve',
    'diez', 'once', 'doce', 'trece', 'catorce', 'quince', 'dieciséis', 'diecisiete',
    'dieciocho', 'diecinueve', 'veinte', 'veintiuno', 'veintidós', 'veintitrés',
    'veinticuatro', 'veinticinco', 'veintiséis', 'veintisiete', 'veintiocho', 'veintinueve'
];

const DECENAS = [
    '', '', 'veinte', 'treinta', 'cuarenta', 'cincuenta', 'sesenta', 'setenta', 'ochenta', 'noventa'
];

const CENTENAS = [
    '', 'ciento', 'doscientos', 'trescientos', 'cuatrocientos', 'quinientos',
    'seiscientos', 'setecientos', 'ochocientos', 'novecientos'
];

// Escalas largas del español: un millón de millones es un billón.
const ESCALAS = [
    { valor: 1e12, singular: 'un billón', plural: 'billones' },
    { valor: 1e6, singular: 'un millón', plural: 'millones' },
];

// "uno" se apocopa a "un" cuando acompaña a mil, millones o billones:
// veintiún mil, treinta y un millones.
const apocopar = (texto) => texto
    .replace(/veintiuno$/, 'veintiún')
    .replace(/(^|\s)uno$/, '$1un');

// 1 a 999
const grupo = (n) => {
    if (n === 100) return 'cien';

    const centena = Math.floor(n / 100);
    const resto = n % 100;
    const partes = [];

    if (centena) partes.push(CENTENAS[centena]);

    if (resto && resto < 30) {
        partes.push(UNIDADES[resto]);
    } else if (resto) {
        const decena = Math.floor(resto / 10);
        const unidad = resto % 10;
        partes.push(unidad ? `${DECENAS[decena]} y ${UNIDADES[unidad]}` : DECENAS[decena]);
    }

    return partes.join(' ');
};

// 1 a 999.999
const hastaMillon = (n) => {
    const miles = Math.floor(n / 1000);
    const resto = n % 1000;
    const partes = [];

    if (miles === 1) partes.push('mil');
    else if (miles > 1) partes.push(`${apocopar(grupo(miles))} mil`);

    if (resto) partes.push(grupo(resto));

    return partes.join(' ');
};

const enLetras = (n) => {
    if (n === 0) return 'cero';

    for (const escala of ESCALAS) {
        if (n >= escala.valor) {
            const cantidad = Math.floor(n / escala.valor);
            const resto = n % escala.valor;
            const cabeza = cantidad === 1
                ? escala.singular
                : `${apocopar(enLetras(cantidad))} ${escala.plural}`;
            return resto ? `${cabeza} ${enLetras(resto)}` : cabeza;
        }
    }

    return hastaMillon(n);
};

/**
 * numToWords :: (Number a, String a) => a -> String
 *
 * Los centavos se redondean al peso más cercano, como lo hacía la versión
 * anterior; los importes del sistema son pesos enteros.
 */
const numToWords = (n) => enLetras(Math.round(Math.abs(Number(n) || 0)));

export default numToWords
